import styled from 'styled-components'
import { StyledTabs } from '~/components/Tabs'
import { MediaBreakPointUp } from '~/theme'

export const StyledOrderListWrapper = styled.div`
  align-items: flex-start;
  background: ${({ theme }) => theme.colors.bgCard};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  margin: 0 auto 16px auto;
  max-width: 435px;
  padding: 20px 0 0 0;
  position: relative;
  overflow: hidden;
  border: 0.5px solid ${({ theme }) => theme.colors.borderBrand};

  @media screen and (max-width: ${MediaBreakPointUp.sm}) {
    width: calc(100% - 30px);
    box-sizing: border-box;
  }
`

export const StyledOrderList = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 8px 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.bgCard};
`

export const StyledOrder = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  padding: 24px 0;
  width: calc(100% - 30px);
  margin: 0 15px;
  box-sizing: border-box;

  &:last-of-type {
    border-bottom: none;
  }

  &:first-of-type {
    padding-top: 5px;
  }
`

export const StyledTokens = styled.div`
  color: ${({ theme }) => theme.colors.textTitle};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: space-between;
  line-height: 140%;
  margin-bottom: 8px;

  img {
    margin: 0 8px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 4px;
  width: 100%;

  .label {
    color: ${({ theme }) => theme.colors.textCaption};
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.242667px;
    line-height: 140%;
  }

  .value {
    color: ${({ theme }) => theme.colors.textStrong};
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
  }

  .lon-tooltip {
    margin-left: auto;
  }
`

export const OrderStatus = styled.div`
  color: ${({ theme }) => theme.colors.textCaption};
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  white-space: nowrap;

  &.expired {
    color: ${({ theme }) => theme.colors.textDanger};
  }

  &.fulfilled {
    color: ${({ theme }) => theme.colors.statusSuccess};
  }
`

export const OrderNote = styled.div`
  background: #fffae9;
  border: 0.5px solid #f3e7c7;
  border-radius: 12px;
  color: #928761;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 8px;
  padding: 8px 12px;
`

export const CancelButton = styled.button`
  background: transparent;
  border: 0.5px solid ${({ theme }) => theme.colors.textTertiary};
  border-radius: 24px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 12px;
  font-weight: 500;
  line-height: 140%;
  margin-top: 8px;
  padding: 8px 20px;
`

export const StyledEmptyOrder = styled.div`
  color: #e9e9e9;
  font-size: 13px;
  font-weight: 400;
  line-height: 140%;
  margin: 35px auto 28px;
  text-align: center;
  width: 64px;

  .note {
    margin-top: 8px;
  }
`

export const OrderTabs = styled(StyledTabs)`
  width: 100%;
  padding-left: 1em;
  padding-bottom: 1em;
`
